import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { INotificationView } from './interfaces';

import { CloseIcon } from '@icons';
import { useStyles } from './styles';
import NotificationButton from './NotificationButton';

const NotificationView = React.forwardRef<HTMLDivElement, INotificationView>(
  (
    {
      title = '',
      message,
      color,
      colorIcon,
      background,
      icon: Icon,
      reloadPage,
      onDismiss,
      withReloadButton = false,
      withDismissButton = true,
      onClickClose,
      dismissButtonText,
      reloadPageAction,
      reloadPageText,
      dismissButtonAction,
    },
    ref,
  ) => {
    const hasIcon = !!Icon;
    const classes = useStyles({ color, hasIcon, colorIcon, background });
    const { t: translate } = useTranslation();

    return (
      <Box ref={ref} sx={classes.root}>
        <Box sx={classes.iconContainer}>
          {Icon ? <Icon sx={classes.icon} /> : null}
          <CloseIcon sx={classes.closeIcon} onClick={onClickClose} />
        </Box>
        <Typography sx={classes.title}>{title || message}</Typography>
        {!!title && <Typography sx={classes.message}>{message}</Typography>}
        <Box sx={classes.buttonsContainer}>
          {withDismissButton && (
            <NotificationButton
              onClick={dismissButtonAction || onDismiss}
              color={color}
            >
              {dismissButtonText || translate('notifications.doNotShowAgain')}
            </NotificationButton>
          )}
          {withReloadButton && (
            <NotificationButton
              onClick={reloadPageAction || reloadPage}
              color={color}
              primary
            >
              {reloadPageText || translate('notifications.reloadPage')}
            </NotificationButton>
          )}
        </Box>
      </Box>
    );
  },
);

NotificationView.displayName = 'NotificationView';

export default NotificationView;
